// Passive event listeners - for google page speed
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    },
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    },
};

/****
*************
*************
  Off-Canvas Nav Functions
*************
*************
*****/
$('#desktopToggler').click(function() {
  $('.off-canvas-transform-menu').addClass('nav-flex');
  $('#siteVisibleArea').removeClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').addClass('site-visible-area');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner');
  $('#canvasX').delay(500).fadeIn();
  $('#offCanvasMenu').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
});

var mobileClicked = 0;

$('#mobileToggler').click(function() {
  if( mobileClicked == 0) {
    $('#siteVisibleArea').removeClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').addClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-mobile');
    $('#offCanvasMobile').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
    mobileClicked = 1;
  }
  else if(mobileClicked == 1) {
    $('#siteVisibleArea').addClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').removeClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-mobile');
    $('#offCanvasMenu').hide();
    mobileClicked = 0;
  }
});

$('#canvasX').click(function() {
  $('.off-canvas-transform-menu').removeClass('nav-flex');
  $('#siteVisibleArea').addClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').removeClass('site-visible-area');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner');
  $('#canvasX').hide();
  $('#offCanvasMenu').hide();
});

/****
*************
*************
  Document Ready Functions
*************
*************
*****/
jQuery(document).ready(function($) {
  //Transparent nav scrolling function

  // Hamburger Menu
  var $hamburger = $(".hamburger-desktop");
    $hamburger.on("click", function() {
      $hamburger.toggleClass("is-active");
  });

  var $mobileHamburger = $(".hamburger-mobile");
    $mobileHamburger.on("click", function() {
      $mobileHamburger.toggleClass("is-active");
  });

  $("#offcanvas-navleft .hamburger").click(function(){
    $(".hamburger-desktop").removeClass("is-active");
  });

  // Toggle SVG icons on menu open / close
  $("button.navbar-toggler").click(function(){
    $(".navbar-toggler-icon").toggleClass("navbar-toggler-icon-close");
  });

  /** navigation hover functions **/
  // function toggleDropdown (e) {
  //   var d = $(this);
  //   var m = $($(this).find('.dropdown-menu')[0]);
  //
  //   setTimeout(function(){
  //     var shouldOpen = e.type !== 'click' && d.is(':hover');
  //     m.toggleClass('show', shouldOpen);
  //     d.toggleClass('show', shouldOpen);
  //     $('[data-toggle="dropdown"]', d).attr('aria-expanded', shouldOpen);
  //   }, e.type === 'mouseleave' ? 50 : 0);
  // }
  //
  // $(window).on('load resize', function() {
  //     $('body').on('mouseenter mouseleave','.dropdown',toggleDropdown);
  // });

  //modal functions for team bios
  $('.open-bio').click(function() {
     $('.header-style-3-nav').css({'z-index':'2'});
     var bio_id = $(this).attr('bio_target');
     if($(this).hasClass('bio_999')) {
       $('#bio_999').addClass('d-block');
     } else {
       $('#'+bio_id).addClass('d-block');
     }
  });
  $('.modal-header button.close').click(function() {
      $('.modal').removeClass('d-block');
      $('.modal').addClass('d-none');
      $('.header-style-3-nav').css({'z-index':'10001'});
  });

});



// WEBPACK FOOTER //
// ./scripts/theme.js